var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_67_7",
    "data-name": "Component 67 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.658,
    height: 9.882,
    viewBox: "0 0 5.658 9.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111080",
    "data-name": "Path 111080",
    d: "M1.546,12.211,5.94,7.831a.46.46,0,0,0,.111-.169.565.565,0,0,0,.032-.2.573.573,0,0,0-.033-.2A.463.463,0,0,0,5.94,7.1L1.546,2.708a.619.619,0,0,0-.456-.183.64.64,0,0,0-.469.2.63.63,0,0,0,0,.913L4.454,7.466.621,11.3a.611.611,0,0,0-.183.45.631.631,0,0,0,.2.463.63.63,0,0,0,.913,0Z",
    transform: "translate(-0.425 -2.525)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.e4cec335fa440b0920ef90f731dee700.svg";
export { ForwardRef as ReactComponent };